import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { home, system_manager } from '../../../assets/conf_urls.json';

@Injectable()

export class ReportIssueService {

  constructor(private http: HttpClient) {
  }

  reportAnIssue(userWhoMadeRequest: string, title: string,
    contactEmail: string, description: string): Observable<any> {
    return this.http.post<any>(home.reportIssue, {
      "requested_by": userWhoMadeRequest,
      "title": title,
      "contact_email": contactEmail,
      "description": description
    })
  }


}
